const summary = "MobileNav-module_summary_IIqIcJuQ";
const open = "MobileNav-module_open_Mih8I5Te";
const root = "MobileNav-module_root_Ac6QAhea";
const close = "MobileNav-module_close_DS2LPcB0";
const panel = "MobileNav-module_panel_0ZdT12Rl";
const main = "MobileNav-module_main_QKTFyNrK";
const list = "MobileNav-module_list_rlk4gumE";
const listItem = "MobileNav-module_listItem_ZB6MgJRS";
const item = "MobileNav-module_item_nR2PqfIk";
const nested = "MobileNav-module_nested_9KhnraVf";
const dropdownSummary = "MobileNav-module_dropdownSummary_OTYG7wu6";
const dropdownIndicator = "MobileNav-module_dropdownIndicator_Fa52Lyzq";
const dropdown = "MobileNav-module_dropdown_lG-T5V5u";
const dropdownSection = "MobileNav-module_dropdownSection_wTlRpFzg";
const dropdownHeading = "MobileNav-module_dropdownHeading_VPBVuJAV";
const dropdownList = "MobileNav-module_dropdownList_44Kjlzdg";
const footer = "MobileNav-module_footer_ozFZmufy";
const footerList = "MobileNav-module_footerList_eMiI-EI6";
const footerLink = "MobileNav-module_footerLink_NbFgTloa";
const footerButtons = "MobileNav-module_footerButtons_-pLohSmI";
const styles = {
  summary,
  open,
  root,
  close,
  panel,
  main,
  list,
  listItem,
  item,
  nested,
  dropdownSummary,
  dropdownIndicator,
  dropdown,
  dropdownSection,
  dropdownHeading,
  dropdownList,
  footer,
  footerList,
  footerLink,
  footerButtons
};
export {
  close,
  styles as default,
  dropdown,
  dropdownHeading,
  dropdownIndicator,
  dropdownList,
  dropdownSection,
  dropdownSummary,
  footer,
  footerButtons,
  footerLink,
  footerList,
  item,
  list,
  listItem,
  main,
  nested,
  open,
  panel,
  root,
  summary
};
